export default __webpack_public_path__ + "static/xr_glasses_m-f6ebd8d55cdde965c0af9eed0d57b5d6.png";